import React, { FC } from 'react';
import NavItem from '../nav-item/nav-item';
import { ISocialFeedsGroupedItem, SocialFeedsTypesMap } from '../../../../shared/mappers/map-social-feeds';
import { IQueryParamFilters } from '../../../../shared/services/api.service';

export interface INavListProps {
  socialFeeds: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>;
  handleOnNavItemClick: (payload: IQueryParamFilters) => void;
  navItemColor: string;
}

export const NavList: FC<INavListProps> = ({ socialFeeds, handleOnNavItemClick, navItemColor }) => {
  return (
    <>
      {Object.entries({ home: [], ...socialFeeds }).map(([key, value]) => {
        return (
          <NavItem key={key} navItemColor={navItemColor} name={key} items={value} onClick={handleOnNavItemClick} />
        );
      })}
    </>
  );
};

export default NavList;
